  // Export
  module.exports =
  {

    // The colours
    _COLOURS: ['#2E97D0', '#99D2F1', '#CBE6F5', '#C9C8D7', '#9290B0', '#262261',
      pattern.draw('dot', '#2E97D0'),
      pattern.draw('dot', '#99D2F1'),
      pattern.draw('dot', '#CBE6F5'),
      pattern.draw('dot', '#C9C8D7'),
      pattern.draw('dot', '#9290B0'),
      pattern.draw('dot', '#262261'),
    ], 

    // View scripts
    view:
    {

      // Method-wide scripts
      _init: function ()
      {

        // On changing the company
        $('#company_id').not('.js-ignore').change(function ()
        {
          
          // Get the company ID
          var company_id = $(this).val()

          // Get the site status
          var site_status = $('#site_status').val() || 'live';

          // If a company
          if ('' !== company_id)
          {

            if (!$('#loader-content').hasClass('hide'))
            {
              $('#loader-content').addClass('hide');
            }

            if ($('#loader').hasClass('hide'))
            {
            
              $('#loader').removeClass('hide');
            }


            //total_reports = $('#total_reports').val();
            var total_reports = 0;
            var report_count = 0;
            
            // Iterate over each report
            $('.js-report').each(function ()
            {
              total_reports++; //now 1?
              // Get the path
              var path = $(this).data(APPLICATION._DATA_PREFIX + 'path')

              // Get the method
              var method = $(this).data(APPLICATION._DATA_PREFIX + 'method')

              // Load the report
              APPLICATION._APPLICATION.load($(this), APPLICATION._PATH_PREFIX + 'report/' + path + '?company_id=' + company_id + '&site_status=' + site_status, 'Report', method, function () {
                //this is called after report loads.
                report_count++;
                
                
                if (total_reports == report_count)
                {

                  if (!$('#loader').hasClass('hide'))
                  {
                    $('#loader').addClass('hide')
                  }

                  if ($('#loader-content').hasClass('hide'))
                  {
                    $('#loader-content').removeClass('hide')
                  }


                }
              })

            }
            )

          }

        }
        ).addClass('js-ignore').trigger('change')
        
      }

    },
    developmentsNext:
    {
      _init: function()
      {
        // Process the links
        APPLICATION._APPLICATION.processLinks('#developments-next', 'Report', 'developmentsNext')
        // On updating
        $('#next-limit').not('.js-ignore').change(function()
        {
          //console.log('next' + $(this).val());
          //reload results with correct pagination.
          company_id =  $('#company_id').val();
          
          var path = $('#developments-next').data(APPLICATION._DATA_PREFIX + 'path')

          // Get the method
          var method = $('#developments-next').data(APPLICATION._DATA_PREFIX + 'method')

          // Load the report
          APPLICATION._APPLICATION.load($('#developments-next'), APPLICATION._PATH_PREFIX + 'report/' + path + '?company_id=' + company_id  + '&limit=' + $(this).val(), 'Report', method)
          
        });
      }
    },
    developmentsNonlive:
    {
      _init: function()
      {
        
        // Process the links
        APPLICATION._APPLICATION.processLinks('#developments-nonlive', 'Report', 'developmentsNonlive')
        // On updating
        $('#non-limit').not('.js-ignore').change(function()
        {
          //console.log('non' + $(this).val());
          //reload results with correct pagination.
          company_id =  $('#company_id').val();
          
          var path = $('#developments-nonlive').data(APPLICATION._DATA_PREFIX + 'path')

          // Get the method
          var method = $('#developments-nonlive').data(APPLICATION._DATA_PREFIX + 'method')

          // Load the report
          APPLICATION._APPLICATION.load($('#developments-nonlive'), APPLICATION._PATH_PREFIX + 'report/' + path + '?company_id=' + company_id  + '&limit=' + $(this).val(), 'Report', method)
          
        });
      }
    },
    developmentsLive:
    {
      _init: function()
      {
        
        // Process the links
        APPLICATION._APPLICATION.processLinks('#developments-live', 'Report', 'developmentsLive')
        // On updating
        $('#live-limit').not('.js-ignore').change(function()
        {
          //console.log('live' + $(this).val());
          //reload results with correct pagination.
          company_id =  $('#company_id').val();
          
          var path = $('#developments-live').data(APPLICATION._DATA_PREFIX + 'path')

          // Get the method
          var method = $('#developments-live').data(APPLICATION._DATA_PREFIX + 'method')

          // Load the report
          APPLICATION._APPLICATION.load($('#developments-live'), APPLICATION._PATH_PREFIX + 'report/' + path + '?company_id=' + company_id  + '&limit=' + $(this).val(), 'Report', method)
          
        });
      }
    },
    developmentsSchedule:
    {
      _init: function()
      {
        
        // Process the links
        APPLICATION._APPLICATION.processLinks('#developments-schedule', 'Report', 'developmentsSchedule')
        // On updating
        $('#schedule_limit').not('.js-ignore').change(function()
        {
          //console.log('schedule' + $(this).val());
          //reload results with correct pagination.
          company_id =  $('#company_id').val();
          
          var path = $('#developments-schedule').data(APPLICATION._DATA_PREFIX + 'path')

          // Get the method
          var method = $('#developments-schedule').data(APPLICATION._DATA_PREFIX + 'method')

          // Load the report
          //console.log(APPLICATION._PATH_PREFIX + 'report/' + path + '?company_id=' + company_id  + '&limit=' + $(this).val());
          APPLICATION._APPLICATION.load($('#developments-schedule'), APPLICATION._PATH_PREFIX + 'report/' + path + '?company_id=' + company_id  + '&limit=' + $(this).val(), 'Report', method)
          
          
        });
        
      }
    },
    futurePipeline:
    {
      _init: function()
      {
        // Process the links
        APPLICATION._APPLICATION.processLinks('#future-pipeline', 'Report', 'futurePipeline')
        $('#limit').not('.js-ignore').change(function()
        {
          //console.log('future' + $(this).val());
          //reload results with correct pagination.
          company_id =  $('#company_id').val();
          
          var path = $('#future-pipeline').data(APPLICATION._DATA_PREFIX + 'path')

          // Get the method
          var method = $('#future-pipeline').data(APPLICATION._DATA_PREFIX + 'method')

          // Load the report
          //console.log(APPLICATION._PATH_PREFIX + 'report/' + path + '?company_id=' + company_id  + '&limit=' + $(this).val());
          APPLICATION._APPLICATION.load($('#future-pipeline'), APPLICATION._PATH_PREFIX + 'report/' + path + '?company_id=' + company_id  + '&limit=' + $(this).val(), 'Report', method)
          
        });
        
      }
    },
    connectionPerformanceByDivision:
    {
      _init: function ()
      {

        var divisions   = JSON.parse($('#connection-performance-by-division-hidden').val()),
          dates         = JSON.parse($('#connection-performance-by-division-hidden-dates').val()),
          lineChartData = {
            labels: dates,
            datasets: [
              {
                label: 'Central',
                lineTension: 0,
                backgroundColor: 'rgba(211,235,255,1)',
                borderColor: "rgba(211,235,255,1)",
                pointBorderColor: "rgba(211,235,255,1)",
                pointBackgroundColor: "rgba(211,235,255,1)",
                pointHoverBackgroundColor: "rgba(211,235,255,1)",
                pointHoverBorderColor: "rgba(211,235,255,1)",
                fill: false,
                data: Object.values(divisions['Central'])
              },
              {
                label: 'North / Wales',
                lineTension: 0,
                backgroundColor: 'rgba(72,186,239, 1)',
                borderColor: "rgba(72,186,239, 1)",
                pointBorderColor: "rgba(72,186,239, 1)",
                pointBackgroundColor: "rgba(72,186,239, 1)",
                pointHoverBackgroundColor: "rgba(72,186,239, 1)",
                pointHoverBorderColor: "rgba(72,186,239, 1)",
                fill: false,
                data: Object.values(divisions['North / Wales'])
              },
              {
                label: 'Northern',
                lineTension: 0,
                backgroundColor: 'rgba(52,0,123, 1)',
                borderColor: "rgba(52,0,123, 1)",
                pointBorderColor: "rgba(52,0,123, 1)",
                pointBackgroundColor: "rgba(52,0,123, 1)",
                pointHoverBackgroundColor: "rgba(52,0,123, 1)",
                pointHoverBorderColor: "rgba(52,0,123, 1)",
                fill: false,
                data: Object.values(divisions['Northern'])
              },
              {
                label: 'South',
                lineTension: 0,
                backgroundColor: 'rgba(250,107,107, 1)',
                borderColor: "rgba(250,107,107, 1)",
                pointBorderColor: "rgba(250,107,107, 1)",
                pointBackgroundColor: "rgba(250,107,107, 1)",
                pointHoverBackgroundColor: "rgba(250,107,107, 1)",
                pointHoverBorderColor: "rgba(250,107,107, 1)",
                fill: false,
                data: Object.values(divisions['South'])
              },
              {
                label: 'South East',
                lineTension: 0,
                backgroundColor: 'rgba(137,0,0, 1)',
                borderColor: "rgba(137,0,0, 1)",
                pointBorderColor: "rgba(137,0,0, 1)",
                pointBackgroundColor: "rgba(137,0,0, 1)",
                pointHoverBackgroundColor: "rgba(137,0,0, 1)",
                pointHoverBorderColor: "rgba(137,0,0, 1)",
                fill: false,
                data: Object.values(divisions['South East'])
              }
            ]
          }

        var chart = new Chart('connection-performance-by-division-chart',
        {
          type: 'line',
          data: lineChartData,
          options: {
            responsive: true,
            tooltips:
            {
              callbacks:
              {
                label: function (tooltipItem, data)
                {
                  return Math.round(tooltipItem.yLabel) + '%'
                }
              }
            },
            scales: {
              xAxes: [{
                ticks:
                {
                  autoSkip: false
                }
              }],
              yAxes: [
                {
                  ticks: {
                    callback: function(value, index, values)
                    {
                      return value + '%';
                    },
                    min: 0,
                    max: 100,
                  },
                  scaleLabel: {
                    display: true,
                    labelString: 'Percentage',
                  },
                },
              ]
            },
            legend:
            {
              display: true,
            }
          }
        })

      }
    },
    connectionDelayByReason:
    {
      _init: function ()
      {

        var dates       = JSON.parse($('#connection-delay-by-reason-dates-hidden').val()),
          reasons       = JSON.parse($('#connection-delay-by-reason-data-hidden').val()),
          backhaul_delay_values = Object.values(reasons['backhaul_delay']),
          site_issue_values = Object.values(reasons['site_issue']),
          installation_forward_values = Object.values(reasons['installation_forward']),
          installation_delay_values = Object.values(reasons['installation_delay']),
          provisioning_delay_values = Object.values(reasons['provisioning_delay'])

        var max = Math.max(
          Math.max.apply(null, backhaul_delay_values),
          Math.max.apply(null, site_issue_values),
          Math.max.apply(null, installation_forward_values),
          Math.max.apply(null, installation_delay_values),
          Math.max.apply(null, provisioning_delay_values)
        )

        var lineChartData = {
            labels: dates,
            datasets: [
              {
                label: 'Backhaul Delay',
                lineTension: 0,
                backgroundColor: 'rgba(211,235,255,1)',
                borderColor: "rgba(211,235,255,1)",
                pointBorderColor: "rgba(211,235,255,1)",
                pointBackgroundColor: "rgba(211,235,255,1)",
                pointHoverBackgroundColor: "rgba(211,235,255,1)",
                pointHoverBorderColor: "rgba(211,235,255,1)",
                fill: false,
                data: backhaul_delay_values
              },
              {
                label: 'Site Issue',
                lineTension: 0,
                backgroundColor: 'rgba(72,186,239, 1)',
                borderColor: "rgba(72,186,239, 1)",
                pointBorderColor: "rgba(72,186,239, 1)",
                pointBackgroundColor: "rgba(72,186,239, 1)",
                pointHoverBackgroundColor: "rgba(72,186,239, 1)",
                pointHoverBorderColor: "rgba(72,186,239, 1)",
                fill: false,
                data: site_issue_values
              },
              {
                label: 'Installation Delay (LCD brought forward)',
                lineTension: 0,
                backgroundColor: 'rgba(52,0,123, 1)',
                borderColor: "rgba(52,0,123, 1)",
                pointBorderColor: "rgba(52,0,123, 1)",
                pointBackgroundColor: "rgba(52,0,123, 1)",
                pointHoverBackgroundColor: "rgba(52,0,123, 1)",
                pointHoverBorderColor: "rgba(52,0,123, 1)",
                fill: false,
                data: installation_forward_values
              },
              {
                label: 'Installation Delay',
                lineTension: 0,
                backgroundColor: 'rgba(250,107,107, 1)',
                borderColor: "rgba(250,107,107, 1)",
                pointBorderColor: "rgba(250,107,107, 1)",
                pointBackgroundColor: "rgba(250,107,107, 1)",
                pointHoverBackgroundColor: "rgba(250,107,107, 1)",
                pointHoverBorderColor: "rgba(250,107,107, 1)",
                fill: false,
                data: installation_delay_values
              },
              {
                label: 'Provisioning Delay',
                lineTension: 0,
                backgroundColor: 'rgba(126, 34, 206, 1)',
                borderColor: "rgba(126, 34, 206, 1)",
                pointBorderColor: "rgba(126, 34, 206, 1)",
                pointBackgroundColor: "rgba(126, 34, 206, 1)",
                pointHoverBackgroundColor: "rgba(126, 34, 206, 1)",
                pointHoverBorderColor: "rgba(126, 34, 206, 1)",
                fill: false,
                data: provisioning_delay_values
              }
            ]
          }

        var chart = new Chart('connection-delay-by-reason-chart',
        {
          type: 'line',
          data: lineChartData,
          options: {
            responsive: true,
            tooltips:
            {
              callbacks:
              {
                label: function (tooltipItem, data)
                {
                  return Math.round(tooltipItem.yLabel) + '%'
                }
              }
            },
            scales: {
              xAxes: [{
                ticks:
                {
                  autoSkip: false
                }
              }],
              yAxes: [
                {
                  ticks: {
                    callback: function(value, index, values)
                    {
                      return value + '%';
                    },
                    min: 0,
                    max: max
                  },
                  scaleLabel: {
                    display: true,
                    labelString: 'Percentage',
                  },
                },
              ]
            },
            legend:
            {
              display: true,
            }
          }
        })
  
      }

    },
    averageServiceDelay:
    {
      _init: function ()
      {
        
        var MONTHS = $('#average-service-delay-dates').val().split(',')
          console.log('months: ', MONTHS)
          var DelayList = JSON.parse($('#average-service-delay-values').val());
          console.log('delayList: ', DelayList)
          //console.log(typeof(DelayList));
          //console.log(typeof(MONTHS));
          var barChartData = {
            labels: MONTHS,
            datasets: [{
              
                      backgroundColor: 'rgba(71,186,239,1)',
                      borderColor: "rgba(71,186,239,1)",
                      pointBorderColor: "rgba(71,186,239,1)",
                      pointBackgroundColor: "rgba(71,186,239,1)",
                      pointHoverBackgroundColor: "rgba(71,186,239,1)",
                      pointHoverBorderColor: "rgba(71,186,239,1)",
                      fill: false,
                      data: DelayList
            }]

          };
          var chart = new Chart('average-service-delay-chart',
         {
            type: 'line',
            data: barChartData,
            options: {
              responsive: true,
              scales: {
                  
                  xAxes: [{
                      ticks:
                      {
                          autoSkip: false
                      }
                  }]
              },
              legend:
              {
                display: false
              }
            }
            })



        
      }
    },
    
    // Take up by package
    takeUpByPackage:
    {

      // Method-wide scripts
      _init: function ()
      {

        // If a chart
        if (0 !== $('#take-up-by-package-chart').length)
        {

          // Create the pie chart
          var chart = new Chart('take-up-by-package-chart',
          {
            type: 'pie',
            data:
            {
              datasets:
              [
                {
                  data: [
                    $('#take-up-by-package-tin').val(),
                    $('#take-up-by-package-bronze').val(),
                    $('#take-up-by-package-copper').val(),
                    $('#take-up-by-package-silver').val(),
                    $('#take-up-by-package-gold').val(),
                    $('#take-up-by-package-platinum').val(),
                    $('#take-up-by-package-tin-30').val(),
                    $('#take-up-by-package-bronze-30').val(),
                    $('#take-up-by-package-copper-30').val(),
                    $('#take-up-by-package-silver-30').val(),
                    $('#take-up-by-package-gold-30').val(),
                    $('#take-up-by-package-platinum-30').val(),
                  ],
                  backgroundColor: APPLICATION.Report._COLOURS
                }
              ],
              labels: [
                'Tin',
                'Bronze',
                'Copper',
                'Silver',
                'Gold',
                'Platinum',
                'Tin (30 day rolling)',
                'Bronze (30 day rolling)',
                'Copper (30 day rolling)',
                'Silver (30 day rolling)',
                'Gold (30 day rolling)',
                'Platinum (30 day rolling)',
              ]
            },
            options:
            {
              legend:
              {
                display: false
              },
              animation: false
            }
          }
          )

        }

      }

    },
    overallTakeUp:
    {
      // Method-wide scripts
      _init: function ()
      {
        
        // If a chart
        if (0 !== $('#overall-take-up-chart').length)
        {
          
          // Create the pie chart
          var chart = new Chart('overall-take-up-chart',
          {
            type: 'pie',
            data:
            {
              datasets:
              [
                {
                  data: [$('#overall-take-up-total-PD').val(), $('#overall-take-up-total-HA').val(), $('#overall-take-up-take-up').val()],
                  backgroundColor: APPLICATION.Report._COLOURS
                }
              ],
              labels: ['Take Up (PD)','Take Up (HA)', 'Non Take Up']
            },
            options:
            {
              legend:
              {
                display: false
              },
              animation: false
            }
          }
          )

        }

      }
    },
    arpuByBusiness:
    {
      _init: function ()
      {
        
      }
    },
    // Take up by business
    takeUpByBusiness:
    {

      // Method-wide scripts
      _init: function ()
      {

        // If a chart
        if (0 !== $('#take-up-by-business-chart').length)
        {

          // The data sets
          var datasets = []

          // The data
          var data = JSON.parse($('#take-up-by-business-data').val())

          // Add the data sets
          for (i in data)
          {

            // Add the background color
            data[i].backgroundColor = APPLICATION.Report._COLOURS[i]

            // Add the data
            datasets.push(data[i])

          }

          // Create the pie chart
          var chart = new Chart('take-up-by-business-chart',
          {
            type: 'bar',
            data:
            {
              labels: JSON.parse($('#take-up-by-business-companies').val()),
              datasets: datasets,
            },
            options:
            {
              legend:
              {
                display: false
              },
              animation: false,
              scales:
              {
                xAxes:
                [
                {
                  stacked: true,
                  ticks:
                  {
                    autoSkip: false
                  }
                }
                ],
                yAxes:
                [
                {
                  stacked: true,
                  gridLines:
                  {
                    display: false
                  }
                }
                ]
              }
            }
          }
          )

        }

      }

    },
    networkFootprint:
    {

      googleMaps: false,

      _init: function()
      {

        if (!this.googleMaps)
        {
          $.getScript('https://maps.googleapis.com/maps/api/js?key=' + APPLICATION._GOOGLEMAPS_API_KEY + '&callback=initMap')
          this.googleMaps = true
        }

        else
        {
          initMap()
        }

      }
      
      
    },

    // Site summary
    siteSummary:
    {

      // Method-wide scripts
      _init: function ()
      {

        // Process the links
        APPLICATION._APPLICATION.processLinks('#site-summary', 'Report', 'siteSummary')

      }

    },
    // Site summary
    plotPipelineSummary:
    {

      // Method-wide scripts
      _init: function ()
      {

        // Process the links
        APPLICATION._APPLICATION.processLinks('#plot-pipeline-summary', 'Report', 'plotPipelineSummary')

      }

    },
     // Backhaul summary
     backhaulSummary:
     {
 
       // Method-wide scripts
       _init: function ()
       {
 
         // Process the links
         APPLICATION._APPLICATION.processLinks('#backhaul-summary', 'Report', 'backhaulSummary')
 
       }
 
     },

    // Plot issues
    plotIssues:
    {

      // Method-wide scripts
      _init: function ()
      {

        // Process the links
        APPLICATION._APPLICATION.processLinks('#plot-issues', 'Report', 'plotIssues')

      }

    },

    siteConnections:
    {
      _init: function()
      {
        // Process the links
        APPLICATION._APPLICATION.processLinks('#site-connections', 'Report', 'siteConnections')
        
      }

    },
    serviceSummary:
    {
      _init: function()
      {
        console.log('init');
        
          console.log('draw');
          var ctx = document.getElementById('day-1-connections');
          var day1Data = $('#day1Data').val();
          var day1Labels = $('#day1Labels').val();
          var day1Connections = new Chart(ctx, {
            type: 'line',
            data: {
              labels: [day1Labels],

              datasets: {
                data: [day1data]
              }
            },
            options: {

            }
            
          });
        
        console.log('done');
      }
    },
    issueBreakdown:
    {
      _init: function()
      {
        console.log('triggered');
        var plotProblemCompanyData = $('#plotProblemCompanyData').val();
        if (plotProblemCompanyData !== undefined)
        {
          plotProblemCompanyData = plotProblemCompanyData.split(',');
          var plotProblemCompanyLabels = $('#plotProblemCompanyLabels').val().split(',');
          new Chart('company-issue-breakdown', {
            "type": 'pie',
            "data": {
              "labels": plotProblemCompanyLabels,
              "datasets": [{
                "label": "Plot Problems",
                "data": plotProblemCompanyData,
                "backgroundColor": graphColors
              }]
            },
            options:
            {
              legend:
              {
                display: false
              },
              tooltips: false,
              animation: false
            }
          })
        }
          
        var plotProblemGroupData = $('#plotProblemGroupData').val();
        if (plotProblemGroupData !== undefined)
        {
          plotProblemGroupData = plotProblemGroupData.split(',');
          var plotProblemGroupLabels = $('#plotProblemGroupLabels').val().split(',');
          new Chart('group-issue-breakdown', {
            "type": 'pie',
            "data": {
              "labels": plotProblemGroupLabels,
              "datasets": [{
                "label": "Plot Problems",
                "data": plotProblemGroupData,
                "backgroundColor": graphColors
                
              }]
            },
            options:
            {
              legend:
              {
                display: false
              },
              tooltips: false,
              animation: false
            }
          })
        }
      }
    },

    // Site summary
    siteSummaryRelative:
    {

      // Method-wide scripts
      _init: function ()
      {

        // Process the links
        APPLICATION._APPLICATION.processLinks('#site-summary-relative', 'Report', 'siteSummaryRelative')

        $('#relative-offset-btn').not('.js-ignore').click(function ()
        {

          APPLICATION._APPLICATION.load(
            $('#site-summary-relative'),
            $(this).data('url') + '&offset=' + $('#relative-offset').val(),
            'Report',
            'siteSummaryRelative'
          )
          
        }
        ).addClass('js-ignore')

      }

    },

    reviews: require('./report/reviews'),

    downloadStockReport: require('./report/downloadStockReport')

  }